import { isExternalLink } from "@components/clickable/Clickable.utils";
import {
    EntitySetName,
    IUserNotificationEntity,
    NotificationEntity,
    UserNotificationEntity
} from "@odata/GeneratedEntityTypes";
import { WithOData, withOData } from "@odata/withOData";
import React from "react";
import { RouteComponentProps, withRouter } from "react-router-dom";

import BusyIndicator from "../components/busyIndicator";
import { addCompanyIdToUrl } from "../contexts/appContext/AppContext.utils";
import { ROUTE_HOME } from "../routes";
import { getQueryParameters } from "../routes/Routes.utils";
import NumberType from "../types/Number";
import { getNotificationUrl } from "./Notification.utils";
import { WithNotifications, withNotifications } from "./withNotifications";

interface IProps extends WithNotifications, WithOData, RouteComponentProps<{ id: string }> {

}

class NotificationsRedirect extends React.PureComponent<IProps> {
    componentDidMount() {
        this.init();
    }

    init = async () => {
        const notificationId = NumberType.parse(this.props.match.params.id);

        if (notificationId && NumberType.isValid(notificationId)) {
            try {
                const res = await this.props.oData.getEntitySetWrapper(EntitySetName.Notifications)
                    .query(notificationId)
                    .expand(UserNotificationEntity.Notification, q => q
                        .expand(NotificationEntity.NotificationType)
                        .expand(NotificationEntity.Company))
                    .fetchData<IUserNotificationEntity>();
                const notification = res.value;
                let url = getNotificationUrl(notification.Notification);

                if (url) {
                    this.props.notifications.updateNotification({
                        Id: notificationId,
                        IsRead: true
                    });
                    this.props.notifications.refreshNotifications();

                    const queryParams = getQueryParameters({ historyLocation: this.props.location });
                    const companyId = parseInt(queryParams.CompanyId);

                    if (companyId) {
                        url = addCompanyIdToUrl(url, companyId);
                    }

                    if (isExternalLink(url)) {
                        window.location.assign(url);
                    } else {
                        this.props.history.replace(url);
                    }
                    return;
                }
            } catch (e) {
            }
        }

        this.redirectToHome();
    };

    redirectToHome = () => {
        this.props.history.replace(ROUTE_HOME);
    };

    render() {
        return (
            <BusyIndicator/>
        );
    }
}


export default withNotifications(withOData(withRouter(NotificationsRedirect)));